module.exports = __webpack_public_path__ + "static/media/fig_23c.d07092d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_23c.jpg
// module id = 660
// module chunks = 0